import React from 'react';
import PropTypes from 'prop-types';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { IconButton } from '@mui';

const ExportButton = ({ onClick }) => (
  <IconButton onClick={onClick} aria-label="Export" tooltip="Export">
    <SaveAltIcon />
  </IconButton>
);

ExportButton.propTypes = {
  onClick: PropTypes.func
};

export default ExportButton;
